export enum SearchStatusEnum {
  INIT = 'Initial',
  SEARCHING = 'Searching',
  SHOWING_RESULTS = 'Showing Results',
  LOADING_MORE = 'Loading More',
  NO_MORE_RESULTS = 'No more results',
  NO_RESULTS = 'No Results'
}
